// extracted by mini-css-extract-plugin
export default {"newSesone":"newSec_newSesone__Aphd0","left":"newSec_left__q7iQQ","right":"newSec_right__+Aeqi","leftText":"newSec_leftText__cuZIo","rightText":"newSec_rightText__IVg6p"};